/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Firebase from 'firebase/app';
import * as FirebaseUI from 'firebaseui';

import 'global/auth';


const googleProvider =
{
  provider: Firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  customParameters:
  {
    prompt: 'select_account',
  },
};


const facebookProvider =
{
  provider: Firebase.auth.FacebookAuthProvider.PROVIDER_ID,
  scopes:
  [
    'email',
  ],
  customParameters:
  {
    display: 'popup',
  },
};


const anonymousProvider =
{
  provider: FirebaseUI.auth.AnonymousAuthProvider.PROVIDER_ID,
  iconUrl: '/favicon-dark.ico',
  fullLabel: 'Play as Guest',
};


// Server side automatically deletes anonymous users after enough time passes.
const abandonAnonymousUser = () =>
{
  return Firebase.auth().currentUser.delete().catch(() => null);
};


const signInWithExistingAccount = (credential) =>
{
  return Firebase.auth().signInWithCredential(credential);
};


const resolveMergeConflict = (error) =>
{
  return abandonAnonymousUser().then(() => signInWithExistingAccount(error.credential));
};


const onSignInFailure = (error) =>
{
  if (error.code === 'firebaseui/anonymous-upgrade-merge-conflict')
  {
    return resolveMergeConflict(error);
  }

  console.error('Firebase sign-in error!', error);
};


export const getConfig = () =>
(
  {
    signInFlow: 'popup',

    autoUpgradeAnonymousUsers: true,

    tosUrl: '/terms',
    privacyPolicyUrl: '/privacy',

    signInOptions: [ googleProvider, facebookProvider, anonymousProvider ],

    callbacks:
    {
      signInSuccessWithAuthResult: () => false,
      signInFailure: onSignInFailure,
    },
  }
);


export const getUpgradeConfig = () =>
(
  {
    ...getConfig(),

    signInOptions: [ googleProvider, facebookProvider ],
  }
);


export const getInstance = () =>
{
  return FirebaseUI.auth.AuthUI.getInstance() ?? new FirebaseUI.auth.AuthUI(Firebase.auth());
};
